export default __webpack_public_path__ + "static/1-7967cef6a51f5e32e610dc4733e7f547.jpg";